import React, { lazy, Suspense } from 'react';
import Loader2 from 'lucide-react/dist/esm/icons/loader-2.js';
import { useLayoutStyle } from '../contexts/LayoutStyleContext';
import GameHomePage from './GameHomePage';

const LegacyV2GamePage = lazy(() => import('./LegacyV2GamePage'));

function GameRouteLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-charity-primary" />
    </div>
  );
}

export default function GameTypeRoutePage({ gameType, onLoginClick, partnerId, isAdmin }) {
  const { layoutStyle } = useLayoutStyle();

  if (layoutStyle === 'v2') {
    return (
      <Suspense fallback={<GameRouteLoader />}>
        <LegacyV2GamePage
          gameType={gameType}
          onLoginClick={onLoginClick}
          partnerId={partnerId}
          isAdmin={isAdmin}
        />
      </Suspense>
    );
  }

  return (
    <GameHomePage
      gameType={gameType}
      onLoginClick={onLoginClick}
      partnerId={partnerId}
      isAdmin={isAdmin}
    />
  );
}
